export default __webpack_public_path__ + "static/media/img1Light.2326b635.png";